module.exports = __webpack_public_path__ + "img/ergLogo2@2x.850fc353.jpg";